import './less/selectInput.less';
import 'sumoselect';

const SelectInputAutosubmit = () => {
	let select = $('.selectInput__input--autosubmit');
	select.change(function () {
		select.closest('form').submit();
	})
}

const SelectInput = () => {
	let select = $('.selectInput__input');

	select.SumoSelect({});

	SelectInputAutosubmit();

}


const selectInput = SelectInput();
export default selectInput;


// WEBPACK FOOTER //
// ./components/selectInput/selectInput.js